
    document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('contact-formid');
    isContactPosted();

    function isContactPosted() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('contact_posted') === 'true';
}

    if (isContactPosted()) {
    /*form.classList.add('contact-form-success-wrapper');*/

    setTimeout(function() {
    window.location.href = '/pages/contact';
        }, 5000);
    }
});
